import type * as lazyIndex from "./lazyIndex";
import { createLazyComponent, type LazyComponent, LazyModule } from "owa-bundling";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(() => import(/* webpackChunkName: "UpsellModuleAsync" */ "./lazyIndex"), { name: "UpsellModuleAsync" });
export const TopUpsellBannerComponent: LazyComponent<{}, unknown, void> = createLazyComponent(lazyModule, m => m.TopUpsellBanner, undefined, undefined, { govern: true });
